import React, { useEffect } from "react";

import Footer from "../components/footer";
import Switcher from "../components/switcher";
import Team from "../components/team";
import StatsCards from "../components/StatsCards";
import "../../node_modules/react-modal-video/css/modal-video.css";
import Navbar from "../components/navbar";
import VisionMissionValues from "../components/VisionMissionValues";
import HeroComex from "../components/HeroComex";
import useStore from "../store/useStore";
import Seo from "../components/Seo";
import AboutStory from "../components/AboutStory";

export default function AboutUs() {
  const { nosotrosHeroes, getNosotrosHeroes, seoNosotros, fetchSeoNosotros } =
    useStore();
  useEffect(() => {
    getNosotrosHeroes();
    fetchSeoNosotros();
  }, [getNosotrosHeroes, fetchSeoNosotros]);

  return (
    <>
      <Seo
        metaTitle={seoNosotros[0]?.metatitle}
        metaDescription={seoNosotros[0]?.metadescription}
        metaImage={seoNosotros[0]?.metaimage?.url}
        metaKeywords={seoNosotros[0]?.metakeywords}
        canonicalURL={seoNosotros[0]?.canonicalurl}
      />
      <header>
        <Navbar />
      </header>
      <main className="bg-sidom-light dark:bg-sidom-blue text-sidom-dark dark:text-sidom-light">
        {nosotrosHeroes &&
          nosotrosHeroes.map((item, index) => (
            <HeroComex video={item.video[0]?.url} height="h-[300px]" />
          ))}

        <AboutStory />
        <Team />

        <VisionMissionValues />
        <StatsCards />
      </main>
      <footer>
        <Footer />
      </footer>
      <Switcher />
    </>
  );
}
